// src/routes/PublicFaturaRoute.jsx
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams, useParams } from 'react-router-dom';
import { Box, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import pagamentoPublicoService from '../services/pagamentoPublicoService';

const PublicFaturaRoute = ({ children }) => {
  const [searchParams] = useSearchParams();
  const { prestacaoId } = useParams();
  const token = searchParams.get('token');
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const validarAcesso = async () => {
      try {
        if (!token) {
          setError('Token de acesso não fornecido');
          return;
        }

        // Se usuário estiver logado como estudante, verificar se a fatura pertence a ele
        if (user && user.tipo === 'estudante') {
          const response = await pagamentoPublicoService.validarAcessoEstudante(prestacaoId);
          if (!response.success) {
            setError('Você não tem permissão para acessar esta fatura');
            return;
          }
        }

        // Validar token
        await pagamentoPublicoService.validarToken(token);
        setError(null);
      } catch (err) {
        setError(err.message || 'Erro ao validar acesso');
      } finally {
        setLoading(false);
      }
    };

    validarAcesso();
  }, [token, prestacaoId, user]);

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          {error === 'Token de acesso não fornecido' ? (
            <>
              Link de acesso inválido ou expirado.<br/>
              Por favor, solicite um novo link através do seu email.
            </>
          ) : error}
        </Alert>
      </Box>
    );
  }

  // Se tudo estiver ok, renderiza o componente filho
  return children;
};

PublicFaturaRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default PublicFaturaRoute;